import {useUnblockSlotOnMount} from "@App/hooks/useUnblockSlotOnMount";
import {useBlockSlot} from "@App/hooks/graphql/mutations/useBlockSlot";
import useStore from "@App/store";
import {useState} from "react";
import {parseISO, startOfDay} from "date-fns";
import {Slot} from "@App/types";


export const useBooking = () => {

    // unblock a blocked slot, if the user already clicked and blocked a
    // slot in this session
    useUnblockSlotOnMount()
    // block slot graphql api hook for slot reservation
    const {
        triedSlot,
        blockSlot,
        error: errorWhenBlockingSlot,
        loading: loadingWhenBlockingSlot,
        blockedSlot
    } = useBlockSlot()
    const state = useStore()
    const [selectedDay, setSelectedDay] = useState(state.order.slot ? startOfDay(parseISO(state.order.slot.starts_at)) : null)
    const [daysAvailable, setDaysAvailable] = useState(true)
    const [nextSlot, setNextSlot] = useState<Slot|null>(null)
    const [initiallySelectedDay, setInitiallySelectedDay] = useState(null)
    const [isShowingServices, setIsShowingServices] = useState(false)
    const [isShowingCalendar, setIsShowingCalendar] = useState(true)
    const [daysLoading, setDaysLoading] = useState(false)
    const selectedSlot = state.order.slot


    const changeDay = (day: any) => {
        if (!initiallySelectedDay) {
            setInitiallySelectedDay(day)
        }
        setSelectedDay(day)
    }

    const changeSlot = (slot: Slot) => {
        state.setSlot(slot)
        if(selectedSlot && selectedSlot !== nextSlot) {
            setIsShowingCalendar(false)
        }
    }

    const changeEarliestSlot = (slot: Slot) => {
        setNextSlot(slot)
    }

    const selectFirstSlot = () => {
        if (nextSlot) {
            setSelectedDay(startOfDay(parseISO(nextSlot.starts_at)))
            state.setSlot(nextSlot)
        }
    }

    const submit = () => {
        selectedSlot && blockSlot(selectedSlot)
    }

    return {
        changeDay,
        daysAvailable,
        setDaysAvailable,
        setDaysLoading,
        errorWhenBlockingSlot,
        loadingWhenBlockingSlot,
        selectFirstSlot,
        triedSlot,
        nextSlot,
        initiallySelectedDay,
        selectedDay,
        isShowingServices,
        setIsShowingServices,
        isShowingCalendar,
        setIsShowingCalendar,
        selectedSlot,
        daysLoading,
        changeSlot,
        changeEarliestSlot,
        blockSlot,
        blockedSlot,
        submit
    }
}
